import tw from 'twin.macro';

const Divider = tw.hr`m-0 border-0 border-b border-b-grey-five w-full`;

export default Divider;
